import './TargetCalculator.css'

function TargetCalculator({ 
  targetCGPA, 
  remainingSemesters, 
  requiredSGPA,
  completedSemesters,
  totalSemesters,
  creditsBreakdown,
  semesterCredits
}) {
  const isAchievable = requiredSGPA <= 10 && requiredSGPA >= 0
  const isRealistic = requiredSGPA <= 9.5
  const hasValidInputs = targetCGPA && completedSemesters && totalSemesters && parseInt(completedSemesters) < parseInt(totalSemesters)

  const getResultColor = () => {
    if (!isAchievable) return '#dc3545' // Red
    if (!isRealistic) return '#ffc107' // Yellow
    return '#28a745' // Green
  }

  const getResultMessage = () => {
    if (requiredSGPA <= 0) return 'Target already achieved!'
    if (!isAchievable) return 'Target not achievable (SGPA > 10.0)'
    if (!isRealistic) return 'Target is very challenging but possible'
    if (requiredSGPA >= 9.0) return 'Target requires excellent performance'
    if (requiredSGPA >= 8.0) return 'Target is achievable with good effort'
    return 'Target is easily achievable!'
  }

  return (
    <div className="target-calculator">
      <h3>Required SGPA Calculator</h3>
      
      {hasValidInputs ? (
        <div className="result-section">
          <div className="semester-info">
            <div className="info-item">
              <span className="label">Remaining Semesters:</span>
              <span className="value">{remainingSemesters}</span>
            </div>
            <div className="info-item">
              <span className="label">Target CGPA:</span>
              <span className="value">{parseFloat(targetCGPA).toFixed(2)}</span>
            </div>
          </div>

          <div className="required-sgpa">
            <span className="label">Required SGPA per semester:</span>
            <span 
              className="value" 
              style={{ color: getResultColor() }}
            >
              {requiredSGPA.toFixed(2)}
            </span>
          </div>
          
          <div 
            className="result-message"
            style={{ color: getResultColor() }}
          >
            {getResultMessage()}
          </div>
          
          <div className="calculation-breakdown">
            <h4>📊 Calculation Breakdown:</h4>
            <ul>
              <li>Completed: {completedSemesters} semesters ({creditsBreakdown?.completedCredits || 0} credits)</li>
              <li>Remaining: {remainingSemesters} semesters ({creditsBreakdown?.remainingCredits || 0} credits)</li>
              <li>Total Course Credits: {creditsBreakdown?.totalCredits || 0}</li>
              <li>Each remaining semester needs: <strong>{requiredSGPA.toFixed(2)} SGPA</strong></li>
            </ul>
            
            {remainingSemesters > 0 && semesterCredits && (
              <div className="remaining-semesters-detail">
                <h5>📅 Remaining Semesters Credit Distribution:</h5>
                <div className="remaining-credits-grid">
                  {Array.from({ length: remainingSemesters }, (_, index) => {
                    const semNumber = parseInt(completedSemesters) + index + 1
                    const credits = semesterCredits[semNumber]
                    return (
                      <div key={semNumber} className="remaining-credit-item">
                        <span>Sem {semNumber}:</span>
                        <span>{credits} credits</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
          
          <div className="tips">
            <h4>💡 Study Tips:</h4>
            <ul>
              <li>Focus on high-credit subjects for maximum impact</li>
              <li>Maintain consistent study schedule</li>
              <li>Seek help early for challenging subjects</li>
              <li>Form study groups for better understanding</li>
              <li>Regular revision and practice tests</li>
            </ul>
          </div>
        </div>
      ) : (
        <div className="placeholder">
          <p>📝 Fill in all the details above to see your required SGPA</p>
        </div>
      )}
    </div>
  )
}

export default TargetCalculator
